import apiClient from './client';

export interface TripMemberResponse {
  id: number;
  isAdmin: boolean;
  status: string;
  user: {
    id: number;
    name: string;
    username?: string;
    profilePic?: string;
    status: string;
    isAdmin: boolean;
    memberRequestId: number;
  };
}

export const tripMemberService = {
  // Get all trip members
  getTripMembers: async (tripId: string): Promise<TripMemberResponse[]> => {
    const response = await apiClient.get<TripMemberResponse[]>(`/trips/${tripId}/members`);
    return response.data;
  },

  // Add member to trip
  addMember: async (tripId: string, userId: number): Promise<any> => {
    const response = await apiClient.post(`/trips/${tripId}/members`, { userId });
    return response.data;
  },

  // Remove member from trip
  removeMember: async (tripId: string, memberId: number): Promise<void> => {
    await apiClient.delete(`/trips/${tripId}/members/${memberId}`);
  },

  // Update member role (make admin/remove admin)
  updateMemberRole: async (tripId: string, memberId: number, isAdmin: boolean): Promise<any> => {
    const response = await apiClient.put(`/trips/${tripId}/members/${memberId}/role`, {
      isAdmin,
    });
    return response.data;
  },

  // Get pending join requests
  getPendingRequests: async (tripId: string): Promise<any[]> => {
    const response = await apiClient.get(`/trips/${tripId}/members/pending`);
    return response.data;
  },

  // Approve join request
  approveRequest: async (tripId: string, requestId: number): Promise<void> => {
    await apiClient.post(`/trips/${tripId}/members/requests/${requestId}/approve`);
  },

  // Reject join request
  rejectRequest: async (tripId: string, requestId: number): Promise<void> => {
    await apiClient.post(`/trips/${tripId}/members/requests/${requestId}/reject`);
  },

  // Request to join trip
  requestToJoin: async (tripId: string): Promise<any> => {
    const response = await apiClient.post(`/trips/${tripId}/members/request-join`);
    return response.data;
  },
};
